/*
 * HTML converter for Blockquote.
 */
const EmphasisConverter = {

    type: 'emphasis',
    tagName: 'em',

    matchElement: function(el) {
        return el.is('em, i')
    }
}

export {EmphasisConverter}
